import { Controller } from "@hotwired/stimulus"
import { ExecutionSession } from "../services/execution_session.js"

// Connects to data-controller="workflow-execution-session-store-on-connect"
//
// This controller is responsible for managing the workflow execution session storage on connect
export default class extends Controller {
  static values = {
    stepId: String,
    workflowId: String,
    workflowExecutionId: String,
    stepExecutionId: String
  }

  /**
   * To store only workflow execution id:
   *
   *     <div data-controller="workflow-execution-session-store-on-connect"
   *          data-workflow-execution-session-store-on-connect-workflow-execution-id-value="<%= @workflow_execution_id %>"
   *          data-workflow-execution-session-store-on-connect-workflow-id-value="<%= @workflow_id %>"
   *          data-workflow-execution-session-store-on-connect-step-id-value="<%= @step_execution.step.id %>"
   *
   * To store workflow execution id and step execution id:
   *
   *     <div data-controller="workflow-execution-session-store-on-connect"
   *          data-workflow-execution-session-store-on-connect-workflow-execution-id-value="<%= @workflow_execution_id %>"
   *          data-workflow-execution-session-store-on-connect-workflow-id-value="<%= @workflow_id %>"
   *          data-workflow-execution-session-store-on-connect-step-id-value="<%= @step_execution.step.id %>"
   *          data-workflow-execution-session-store-on-connect-step-execution-id-value="<%= @step_execution.id %>"></div>
   */
  connect() {
    const session = new ExecutionSession({ stepId: this.stepIdValue, workflowId: this.workflowIdValue })

    if (this.hasStepExecutionIdValue) {
      session.store(this.workflowIdValue, this.stepIdValue, this.workflowExecutionIdValue, this.stepExecutionIdValue)
    } else if (this.hasWorkflowExecutionIdValue) {
      session.store(this.workflowIdValue, this.stepIdValue, this.workflowExecutionIdValue)
    }
  }
}
